'use client';

import { type FC, useState } from 'react';
import { useInterval } from 'react-use';

import { Img } from 'Components/Img/Img';

import styles from './Banner.component.module.css';

type BannerComponentProps = {
  variant?: 'noBanner';
  _uid?: string;
  title?: string;
  subtitle?: string;
  images?: Array<{
    alt?: string;
    filename?: string;
    title?: string;
  }>;
};

const BannerComponent: FC<BannerComponentProps> = (props) => {
  const { title, subtitle, images = [], _uid, variant } = props;
  const [count, setCount] = useState(0);

  useInterval(() => {
    setCount((count) => (count + 1) % images.length);
  }, 9000);

  // console.log('BannerComponent', subtitle, props);

  return (
    <div className={styles.wrapper} key={_uid} data-variant={variant}>
      <div className="container">
        <div className={styles.images}>
          {images.map((image, index) => (
            <div
              data-index={index}
              className={styles.image}
              data-is-active={count === index}
              key={`${image?.filename}-banner`}
            >
              <Img
                src={`${image?.filename}/m/2000x500`}
                alt={image.alt}
                title={image.title}
                layout="fill"
                priority={index === 0}
                unoptimized
              />
            </div>
          ))}
        </div>
        <h1 className={styles.title}>
          {title}
          <span className={styles.subtitle} hidden={!subtitle}>
            {subtitle}
          </span>
        </h1>
      </div>
    </div>
  );
};

export { BannerComponent };
